import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from 'app/services/token.service';

// Lista de URLs que no necesitan token
const whiteList = [
  'googleapis.com',
  'worldtimeapi.org'
];

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
	const tokenService = inject(TokenService);
	const token = tokenService.accessToken;
	
	// Verificar si la URL está en el whitelist
	const isWhitelisted = whiteList.some(url => req.url.includes(url));

	if (token && !isWhitelisted) {
		const clonedReq = req.clone({
			setHeaders: {
				Authorization: `Bearer ${token}`
			}
		});
		return next(clonedReq);
	}

	return next(req);
};